<template>
  <div id="speaker-parent-container">
    <div
      v-for="speaker in this.episode_cards[episode_index]['bios']"
      :key="speaker"
      :id="speaker"
      class="speaker"
    >
      <div class="speaker-name" :style="{ color: speaker_colors[speaker][0] }">
        {{ speaker }}
      </div>
      <div class="org-name">{{ speaker_short_description[speaker] }}</div>
      <div class="speaker-avatar">
        <img
          class="speaker-avatar-image"
          :style="{ borderColor: speaker_colors[speaker][0] }"
          :src="require('../assets/speaker-avatar/' + speaker + '.jpg')"
          alt="speaker portrait"
        />
      </div>
      <div class="bio">
        {{ bios[speaker] }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import config from "../data/ecchr_config.json";

export default {
  name: "SpeakerBioCard",
  data() {
    return {
      episode_cards: config["episode_cards"],
      speaker_short_description: config["speaker_short_description"],
      bios: config["speaker_bios"],
      speaker_colors: config["speaker_colors"],
    };
  },
  computed: {
    ...mapState(["episode_index", "speakerBio"]),
  },
  watch: {
    speakerBio: function () {
      let firstSpeaker = document.getElementById(this.speakerBio);
      let parent = document.getElementById("speaker-parent-container");

      parent.insertBefore(firstSpeaker, parent.firstChild);
    },
  },
};
</script>

<style scoped>
.speaker {
  font-weight: 300;
  grid-gap: 2px;
  background-color: rgb(44, 44, 46);
  border-radius: 8px;

  display: grid;
  grid-template-columns: 0.75fr 0.25fr;
  gap: 0px 0px;
  grid-template-areas:
    "speaker-name speaker-avatar"
    "org-name speaker-avatar"
    "bio  bio";
  margin-top: 20px;
  margin-bottom: 15px;
  padding: 20px 25px 25px 25px;
}

.speaker-name {
  grid-area: speaker-name;
  font-weight: 700;
  font-size: 16px;
  align-self: flex-end;
  color: rgba(0, 193, 219, 1);
}

.org-name {
  grid-area: org-name;
  font-weight: 400;
  font-size: 16px;
  margin-right: 15px;
}

.speaker-avatar {
  grid-area: speaker-avatar;
  place-self: center;
}

.speaker-avatar-image {
  border-radius: 50%;
  border-width: 3px;
  border-style: solid;
  width: 48px;
  border-color: rgba(0, 193, 219, 1);
}
.benedicte-savoy-avatar {
  border-color: rgb(248, 191, 45, 1);
}
.benedicte-savoy-name {
  color: rgb(248, 191, 45, 1);
}
.benedicte-savoy-chunk {
  background-color: rgb(248, 191, 45, 1);
  opacity: 0.3;
  transition: 0.3s ease-in-out;
}

.fred-ritchin-avatar {
  border-color: rgba(36, 104, 205, 1);
}

.fred-ritchin-name {
  color: rgba(36, 104, 205, 1);
}

.rabih-mroue-avatar {
  border-color: rgba(240, 87, 170, 1);
}

.rabih-mroue-name {
  color: rgba(240, 87, 170, 1);
}

.christina-varvia-avatar {
  border-color: rgba(148, 181, 192, 1);
}

.christina-varvia-name {
  color: rgba(148, 181, 192, 1);
}

.claudia-jimenez-avatar {
  border-color: rgba(232, 79, 125, 1);
}

.claudia-jimenez-name {
  color: rgba(232, 79, 125, 1);
}

.mark-sealy-avatar {
  border-color: rgba(127, 105, 191, 1);
}

.mark-sealy-name {
  color: rgba(127, 105, 191, 1);
}

.ixmucane-aguilar-avatar {
  border-color: rgba(85, 162, 205, 1);
}

.ixmucane-aguilar-name {
  color: rgba(85, 162, 205, 1);
}

.wolfgang-kaleck-avatar {
  border-color: rgba(3, 149, 169, 1);
}

.wolfgang-kaleck-name {
  color: rgba(0, 193, 219, 1);
}

.karina-theurer-avatar {
  border-color: rgba(248, 191, 45, 1);
}

.karina-theurer-name {
  color: rgba(248, 191, 45, 1);
}

.bio {
  grid-area: bio;
  place-self: center;
  padding-top: 25px;
  color: rgb(160, 160, 160);
}
</style>